import React, { useEffect, useState } from "react";
import MultiSelectBox from "../../../components/FormComponents/MultiSelectBox";
import useDirtyChecker from "../../../hooks/useDirtyChecker";
import { useStatemachineContext } from "../../../context/StatemachineContext";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import NotesAndTags from "../../../components/BuilderComponents/NotesAndTags";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import { toastSuccess } from "../../../utils/toastUtils";
import GenericActionBar from "../../../Layouts/GenericActionBar/GenericActionBar";
import { useParams } from "react-router-dom";

const RenderMultiSelect = ({ field, activeSM, rememberData, setRememberData }) => {
  const [selectedMultipleData, setSelectedMultipleData] = useState([]);

  const isStateField =
    field === "allow_state_targets" ||
    field === "deny_states_targets" ||
    field === "allow_state_sources" ||
    field === "deny_states_sources";

  const isGatewayField = field === "allow_gateway_targets";

  const getSourceArray = () => {
    if (isGatewayField) {
      return activeSM.gateways || [];
    } else if (isStateField) {
      return activeSM.states || [];
    } else {
      return activeSM.activities || [];
    }
    // return isStateField ? activeSM.states || [] : activeSM.activities || [];
  };

  const callbackfunction = (newData) => {
    const newObj = { ...rememberData };
    newObj[field] = newData.map((item) => item.id);
    setSelectedMultipleData(newData);
    setRememberData(newObj);
  };

  const getSelectedDataObject = () => {
    const sourceArray = getSourceArray();
    if (Array.isArray(rememberData[field])) {
      const filtered = sourceArray.filter((item) => rememberData[field].includes(item.id));
      setSelectedMultipleData(filtered);
    }
  };

  useEffect(() => {
    getSelectedDataObject();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div key={field}>
      <div className="allow_deny">
        <MultiSelectBox
          options={getSourceArray()}
          selectedData={selectedMultipleData}
          onChange={callbackfunction}
          label={field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, " ")}
        />
      </div>
    </div>
  );
};

const StateOptionsEditor = ({
  rememberData,
  setRememberData,
  textareaValue,
  toggleState,
  setToggleState,
  activeSM,
  smName,
  handleNotesAndTag
}) => {
  const [isSaving, setIsSaving] = useState(false);
  const [showNotesModal, setShowNotesModal] = useState(false);
  const { smId, stateId } = useParams();
  const { selectedStateMachine } = useStatemachineContext();
  const { markClean, isDirty } = useDirtyChecker({
    rememberData,
    textareaValue
  });

  const handleSaveState = async () => {
    try {
      setIsSaving(true);
      let config = {
        remember: rememberData,
        description: textareaValue
      };

      let url = `/state-machine/${smId}/states/${stateId}`;
      const { message, data } = await axiosInstance.put(url, config);
      toastSuccess(message);
      setIsSaving(false);
      markClean();
      return { data: data, message };
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  };

  return (
    <div className="w_100">
      <GenericActionBar
        path={
          <div>
            <em>SM-Workflow</em> → <span>{`${smName}/States/${selectedStateMachine.name}`}</span>
          </div>
        }
        actions={[
          {
            key: "notes",
            icon: "notes",
            title: "Notes",
            onClick: () => setShowNotesModal(!showNotesModal)
          },
          {
            key: "save",
            icon: "save",
            title: isSaving ? "Saving..." : "Save",
            onClick: isSaving ? undefined : handleSaveState
          }
        ]}
        options={{
          save: {
            className: `${isDirty ? "save_glowing" : ""} ${isSaving ? "disabled" : ""}`.trim()
          }
        }}
      />
      <div className="page_main_section state_main_page p_0 overflow_hidden">
        <div className="toggle_states">
          <div className="toggle_text">Advanced Settings:</div>
          <div className={`toggle_switch ${toggleState ? "" : "active"}`} onClick={() => setToggleState(!toggleState)}>
            <div className="toggle_slider"></div>
          </div>
        </div>
        <div className="allow_deny_container">
          <br />
          {Object.keys(rememberData).map((field) => {
            if (toggleState) {
              if (
                field === "allow_state_targets" ||
                field === "allow_activities" ||
                field === "allow_gateway_targets" ||
                rememberData[field].length > 0
              ) {
                return (
                  <RenderMultiSelect
                    key={field}
                    field={field}
                    activeSM={activeSM}
                    rememberData={rememberData}
                    setRememberData={setRememberData}
                  />
                );
              }
            } else {
              return (
                <RenderMultiSelect
                  key={field}
                  field={field}
                  activeSM={activeSM}
                  rememberData={rememberData}
                  setRememberData={setRememberData}
                />
              );
            }
            return null;
          })}
        </div>
      </div>
      <BuilderModal isOpen={showNotesModal} onClose={() => setShowNotesModal(false)} modalName="Add Notes">
        <NotesAndTags notesValue={textareaValue || ""} onChange={handleNotesAndTag} />
      </BuilderModal>
    </div>
  );
};

export default StateOptionsEditor;
